import { usePageTitle } from '@lib/common';
import React from 'react';
import { OccupancyReport } from '../components';

export const OccupancyPage: React.FC = () => {
  usePageTitle('Occupancy Report');
  return <OccupancyReport />;
};
